import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import OrderLinesList, { orderLinesListStyles } from "@dana/Overrides/Components/OrderLinesList";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

orderLinesListStyles.gridContainer = mergeToNew(orderLinesListStyles.gridContainer, {
    gap: 10,
    css: css`
        @media print {
            > [class*="GridOffset"] {
                .card_container__wrapper {
                    padding: 0;
                    margin: 1px 0;
                    [class*="GridItemStyle"] {
                        margin: 0;
                    }
                   
                }
            }
            .shortDescription,
            [class*="TypographyStyle"] {
                font-size: ${fontSizes.xSmall} !important;
                line-height: 1.2;
            }                
        }
    `
});

orderLinesListStyles.productInfoDescriptionGridItem = mergeToNew(orderLinesListStyles.productInfoDescriptionGridItem, {
    css: css`
        @media print {
            font-size: ${fontSizes.xSmall} !important;
            line-height: 1.2;
        }
    `
});

orderLinesListStyles.orderLineCardImageGridItem = mergeToNew(orderLinesListStyles.orderLineCardImageGridItem, {
    width: [10, 10, 2, 2, 2],
    printWidth: 4,
    css: css`
        padding: 8px;
        @media print {
            padding: 15px;
            img {
                max-height: 75px;
                max-width: 75px;
            }
        }
    `,
});
orderLinesListStyles.orderLineCardInfoGridContainer = mergeToNew(orderLinesListStyles.orderLineCardInfoGridContainer, {
    gap: 16,
});

orderLinesListStyles.orderLinePriceGridItem = mergeToNew(orderLinesListStyles.orderLinePriceGridItem, {
    width: [12, 6, 2, 2, 2],
    css: css`
        [data-test-selector="heading"] {
            font-weight: ${fontWeights.semiBold};
            color: ${themeBackgrounds.darkGray};
            line-height: ${lineHeights.default};
            font-size: ${fontSizes.small};
            text-transform: capitalize;
            font-weight: ${fontWeights.semiBold};
            margin-bottom: 10px;
        }
        [data-test-selector*="text_"] {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.default};
            font-weight: ${fontWeights.semiBold};
        }
        @media print {
            display: flex;
        }
    `,
});
orderLinesListStyles.productInfoQtyOrderedGridItem = mergeToNew(orderLinesListStyles.productInfoQtyOrderedGridItem, {
    width: [12, 6, 3, 3, 3],
    printWidth: 12,
    css: css`
        [data-test-selector="heading"] {
            font-weight: ${fontWeights.semiBold};
            color: ${themeBackgrounds.darkGray};
            line-height: ${lineHeights.default};
            font-size: ${fontSizes.small};
            text-transform: capitalize;
            font-weight: ${fontWeights.semiBold};
            margin-bottom: 10px;
        }
        [data-test-selector*="text_"] {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.default};
        }
        &.desktopOnly {
            display: none;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        display: flex;
                    `,
                ],
                "min",
            )}
        }
        &.mobileOnly {
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        display: flex;
                    `,
                ],
                "max",
            )}
        }   
        @media print {
            width: 100%;
        }
    `,
});

orderLinesListStyles.productInfoQtyShippedGridItem = mergeToNew(orderLinesListStyles.productInfoQtyShippedGridItem, {
    width: [12, 6, 3, 3, 3],
    printWidth: 12,
    css: css`
        flex-direction: column;
        [data-test-selector="heading"] {
            font-weight: ${fontWeights.semiBold};
            color: ${themeBackgrounds.darkGray};
            line-height: ${lineHeights.default};
            font-size: ${fontSizes.small};
            text-transform: capitalize;
            font-weight: ${fontWeights.semiBold};
            margin-bottom: 10px;
        }
        [data-test-selector*="text_"] {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.default};
        }

        @media print {
            width: 100%;
            display: flex;
        }
    `,
});

orderLinesListStyles.productInfoSubtotalGridItem = mergeToNew(orderLinesListStyles.productInfoSubtotalGridItem, {
    width: [12, 6, 3, 3, 3],
    printWidth: 12,
    css: css`
        [data-test-selector="heading"] {
            font-weight: ${fontWeights.semiBold};
            color: ${themeBackgrounds.darkGray};
            line-height: ${lineHeights.default};
            font-size: ${fontSizes.small};
            text-transform: capitalize;
            font-weight: ${fontWeights.semiBold};
            margin-bottom: 10px;
        }
        [data-test-selector*="text_"] {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.default};
            font-weight: ${fontWeights.semiBold};
        }

        @media print {
            width: 100%;
        }
    `,
});

orderLinesListStyles.productInfoTotalsGridItem = mergeToNew(orderLinesListStyles.productInfoTotalsGridItem, {
    width: 12,
    css: css`
        padding: 0px;
    `,
});

orderLinesListStyles.addToListClickable = mergeToNew(orderLinesListStyles.addToListClickable, {
    css: css`
        background: transparent !important;
    `,
});

orderLinesListStyles.orderLineInfoGridContainer = mergeToNew(orderLinesListStyles.orderLineInfoGridContainer, {
    offsetCss: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: row;
                    `,
                ],
                "min",
            )}
    `,
    css: css`
        > ${GridOffset} {
            display: grid;
            grid-auto-flow: column;
            grid-auto-columns: minmax(auto, 1fr);
            gap: 10px;

            @media only screen and (max-width: 992px) {
                grid-auto-flow: row;
                grid-template-columns: 1fr 1fr;
            }
        }

        @media print {
            display: grid;
            grid-auto-flow: row;
            grid-auto-columns: 1fr 1fr;
            gap: 8px;
            page-break-inside: avoid;
        }
    `,
});

orderLinesListStyles.productInfoGridItem = mergeToNew(orderLinesListStyles.productInfoGridItem, {
    width: [12, 12, 2, 2, 2],
});
orderLinesListStyles.orderLineInfoGridItem = mergeToNew(orderLinesListStyles.orderLineInfoGridItem, {
    width: [12, 12, 10, 10, 10],
});

orderLinesListStyles.orderLineCardActionsWide = mergeToNew(orderLinesListStyles.orderLineCardActionsWide, {
    above: "sm",
    css: css`
        margin-left: auto;
        button {
            background: transparent;

            &:focus {
                background: transparent;
            }
        }
    `,
});

orderLinesListStyles.titleGridItem  = mergeToNew(orderLinesListStyles.titleGridItem, {
  css: css`
    padding-left: 0;
    @media print {
        padding-left: 5px;
        font-size: ${fontSizes.medium} !important;
        line-height: 1.5;
    }
  `
});

orderLinesListStyles.titleText = mergeToNew(orderLinesListStyles.titleText, {
  css: css`
    padding-top: 24px;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                null,
                css`
                    padding-top: 8px;
                `,
            ],
            "min",
        )}
    `,
});

orderLinesListStyles.orderLineCardInfoGridItem = mergeToNew(orderLinesListStyles.orderLineCardInfoGridItem, {
    css: css` 
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                css`
                    padding: 8px;
                `,
            ],
            "max",
        )}
        @media print {
            padding: 15px;
        }
    `,
});